var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("PermissionSimplePage", {
        attrs: { permission: _vm.hasAddPermission }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasAddPermission,
              expression: "hasAddPermission"
            }
          ]
        },
        [
          _c("div", { staticClass: "make-title" }, [
            _vm._v(_vm._s(_vm.$t("route.organizationUserSettings")))
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "dataForm",
              staticStyle: { width: "600px", "margin-left": "20px" },
              attrs: {
                rules: _vm.rules,
                model: _vm.excelSettings,
                "label-position": "left",
                "label-width": "150px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("organizationUserSettings.excelFormatText"),
                    prop: "format"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: _vm.$t("common.pleaseSelectText") },
                      model: {
                        value: _vm.excelSettings.format,
                        callback: function($$v) {
                          _vm.$set(_vm.excelSettings, "format", $$v)
                        },
                        expression: "excelSettings.format"
                      }
                    },
                    _vm._l(this.excelFormatOption, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: {
                          label: item.display_name,
                          value: item.display_name
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("organizationUserSettings.rowLimitText"),
                    prop: "rowLimit"
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { type: "number" },
                    model: {
                      value: _vm.excelSettings.rowLimit,
                      callback: function($$v) {
                        _vm.$set(_vm.excelSettings, "rowLimit", $$v)
                      },
                      expression: "excelSettings.rowLimit"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("common.remark") } },
                [
                  _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("warningMessage.excelFormatRemarkMessage1"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("warningMessage.excelFormatRemarkMessage2"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("warningMessage.excelFormatRemarkMessage3"))
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("warningMessage.currentExcelSettingMessage")
                  }
                },
                [_c("span", [_vm._v(_vm._s(_vm.currentSettingMessage))])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "uniform-button",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.handleReset()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.reset")) + "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleAdd()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.confirm")) + "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }